var render = function render(_c,_vm){return _c('div',[_c('el-button',{class:[
      { red: _vm.props.column === 'DelayedTasksCount' && _vm.props.rowValue > 0 }
    ],attrs:{"type":"text"},on:{"click":function($event){return _vm.$options.OnDetailClick(_vm.props, _vm.data)}}},[_vm._v(_vm._s(_vm.props.rowValue > 0 ? _vm.props.rowValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""))]),(_vm.props.column === 'TasksCount' && _vm.props.row.TotalHours > 0)?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.TotalHours)+" h")]):_vm._e(),(_vm.props.column === 'DoneTasksCount' && _vm.props.row.DoneTaskHours > 0)?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.DoneTaskHours)+" h")]):_vm._e(),(
      _vm.props.column === 'DelayedTasksCount' && _vm.props.row.DelayedTasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.DelayedTasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'ActualWeekClosedTasksCount' &&
      _vm.props.row.ActualWeekClosedTasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.ActualWeekClosedTasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'WeekBeforeClosedTasksCount' &&
      _vm.props.row.WeekBeforeClosedTasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.WeekBeforeClosedTasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'InProgressTasksCount' &&
      _vm.props.row.InProgressTasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.InProgressTasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'ActualWeekTasksCount' &&
      _vm.props.row.ActualWeekTasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.ActualWeekTasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'WeekAfterTasksCount' &&
      _vm.props.row.WeekAfterTasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.WeekAfterTasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'WeekAfterMas1TasksCount' &&
      _vm.props.row.WeekAfterMas1TasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.WeekAfterMas1TasksHours)+" h")]):_vm._e(),(
      _vm.props.column === 'WeekAfterMas2TasksCount' &&
      _vm.props.row.WeekAfterMas2TasksHours > 0
    )?_c('span',[_vm._v(" / "+_vm._s(_vm.props.row.WeekAfterMas2TasksHours)+" h")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }